import { ErrorService } from "@/framework/errors/ErrorService";
import axios, { AxiosResponse } from "axios";

export enum HttpStatus {
  accepted = 202,
}

export interface IHttpsService {
  sendHttpRequestPost(_body: any, _reqUrl: string): Promise<AxiosResponse>;
}

export class HttpsService implements IHttpsService {
  async sendHttpRequestPost(_body: any, _reqUrl: string, _headers: any = ""): Promise<AxiosResponse> {
    try {
      return await axios.post(_reqUrl, _body, { headers: _headers });
    } catch (e) {
      await new ErrorService().handleError("sendHttpRequestPost: " + e);
      throw e;
    }
  }
}
